<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />
            <td>
              <router-link :to="`/widgets/timeline-lists/${item.id}/edit`">
                {{ item.title }}
              </router-link>
            </td>

            <td class="text-center nowrap">
              <Actions
                :path="`/widgets/timeline-lists/${item.id}`"
                @destroy="$emit('destroy', item)"
                @duplicate="$emit('duplicate', item)"
              />
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: 'Timeline Name',
          align: 'start',
          value: 'title',
          sortable: false,
        },
        {
          align: 'center',
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style></style>
